import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ENewQuestionForm {
  Clear = 'NEW_QUESTION/FORM/CLEAR',
}

export type TNewQuestionClear = ITypedReduxAction<ENewQuestionForm.Clear>;

export const clearNewQuestionFormAction = actionGenerator<ENewQuestionForm.Clear>(ENewQuestionForm.Clear);

export type TNewQuestionFormActions = TNewQuestionClear;
